import { render, staticRenderFns } from "./dataGoods.vue?vue&type=template&id=1fbc1ccd&scoped=true&"
import script from "./dataGoods.vue?vue&type=script&lang=js&"
export * from "./dataGoods.vue?vue&type=script&lang=js&"
import style0 from "./dataGoods.vue?vue&type=style&index=0&id=1fbc1ccd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc1ccd",
  null
  
)

export default component.exports